import {
    DEALERACCOUNTNUMBER_SUCCESS,
    DEALERACCOUNTNUMBER_FAILED,
    RESET_DEALERACCOUNTNUMBER,
    LOADING_DEALERACCOUNTNUMBER,
    NETWORK_ERROR_DEALERACCOUNTNUMBER
} from "../types/index";
import { dealerServices } from "../../config/axios";

const resetDealerAccountNumber = () => {
    return { type: RESET_DEALERACCOUNTNUMBER };
};

const dealerAccountNumber = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_DEALERACCOUNTNUMBER });
    await dealerServices
        .post("getAccountNo", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(dealerAccountNumbersuccess(res.data));
                    break;
                default:
                    dispatch(dealerAccountNumberFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_DEALERACCOUNTNUMBER,
                payload: err
            });
        });
};
function dealerAccountNumbersuccess(data) {
    return {
        type: DEALERACCOUNTNUMBER_SUCCESS,
        payload: data
    };
}
function dealerAccountNumberFailed(data) {
    return {
        type: DEALERACCOUNTNUMBER_FAILED,
        payload: data
    };
}

export { resetDealerAccountNumber, dealerAccountNumber };
